import ToolbarComponent from './toolbar.component'

const ToolbarModule = angular.module('cdbl.layout.toolbar', [

])
  .component('cdblToolbar', ToolbarComponent)
  .name

export default ToolbarModule
